import { render, staticRenderFns } from "./SliderArrow.vue?vue&type=template&id=410c5ea2&"
import script from "./SliderArrow.vue?vue&type=script&lang=ts&"
export * from "./SliderArrow.vue?vue&type=script&lang=ts&"
import style0 from "./SliderArrow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports